import cx from 'classnames';
import { injectIntl } from 'react-intl';
import { defineMessages } from 'react-intl';

import styles from './BlockMessage.module.less';

const messages = defineMessages({
  blockedContentMessage: {
    id: 'blockedContentMessage',
    defaultMessage:
      'The content will be blocked as the domain is not allowed. Request to add a domain.',
  },
  securityWarning: {
    id: 'securityWarning',
    defaultMessage:
      'The HTML code contains javascript and can be dangerous for the Portal. Only use if it is from a trusted source.',
  },
});

const BlockMessage = ({ intl }) => {
  const classBlockMsg = cx('text-center', styles.blockMessage);

  return (
    <div className={classBlockMsg}>
      {intl.formatMessage(messages.blockedContentMessage)}
    </div>
  );
};

export default injectIntl(BlockMessage);
